import { Component, OnInit, Inject, Input } from '@angular/core';
import { MdInputModule, MdCheckboxModule, MdDialog, MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { Utility } from '../../../common/utility';

import { DialogService } from '../../../shared/services/dialog.service';
import { BaseService } from '../../../shared/services/base.service';
import { ValidationService } from '../../../shared/services/validation.service';
import { AppConstants } from '../../../shared/constants/constants';
import { AppMessages } from '../../../shared/constants/messages';

import { DialogComponent } from '../../../components/dialog/dialog.component';
import { FormLabelComponent } from '../../../components/form/label/label.component';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';

import { FormMessageComponent } from '../../../components/form/message/message.component';

import { PayMethodModel, CurrencyModel, InvoicePayMethodModel, PayMethodObjModel } from '../../../models/consultation/cash-sale.model';
import { FormControl, FormArray } from '@angular/forms';
import { isString, isNumber, format } from 'util';
import { Router } from '@angular/router';
import { ConsultationStepInfo } from '../../../models/consultation/consultation.model';
import { ConfirmPayMethodPopupComponent } from './confirm-pay-method-popup.component';
import { CurrencyNumberPipe } from '../../../pipes/currency-number.pipe';
import { PayMethodPopupService } from './pay-method-popup.service';
import { FormControlName } from '@angular/forms/src/directives/reactive_directives/form_control_name';
import { Observable } from 'rxjs/Observable';
import { CurrencyNumberDirective } from '../../../directives/currency-number.directive';

@Component({
  selector: 'pay-method-popup',
  templateUrl: 'pay-method-popup.component.html',
  providers: [
    CurrencyNumberPipe,
    PayMethodPopupService,
    CurrencyNumberDirective
  ]
})
export class PayMethodPopupComponent implements OnInit {
  public isAssignSuccess = false;
  public createGroupForm: FormGroup;
  public createGroupModel = new PayMethodModel();
  public invoicePayMethod = new InvoicePayMethodModel();
  public regex = '\\d*\\.?\\d{1,2}';
  public disallowConfirm = true;
  public inputData;
  public arrResultPay = [];
  public listPaymentShow = [];
  public listPaymentType;
  constructor(
    public utility: Utility,
    public baseService: BaseService,
    public dialogService: DialogService,
    private formBuilder: FormBuilder,
    public dialogRef: MdDialogRef<PayMethodPopupComponent>,
    public router: Router,
    public currencyPipe: CurrencyNumberPipe,
    public payMethodPopupService: PayMethodPopupService,
    public directive: CurrencyNumberDirective,
    @Inject(MD_DIALOG_DATA)
    public data: {
      invoiceId: string;
      currency: CurrencyModel;
      totalDue: string;
      invoicePayMethod: InvoicePayMethodModel;
      rate: number;
      isDisableAccount: boolean;
      groupId: string,
      isFromHistory: string,
      paymentData: any
      isDataEntryMode: boolean;
    }
  ) {
    this.directive.allowNegative = true;
  }

  changeCurrency(payMethod: InvoicePayMethodModel, rate: number) {
    if (payMethod && rate) {
      payMethod.adjustment = parseFloat(payMethod.adjustment) !== 0 ? (parseFloat(payMethod.adjustment) * rate).toFixed(
        2
      ) : null;
      let i = 0;
      const lens = payMethod.payMethod.length;
      while (i < lens) {
        if (parseFloat(
          payMethod.payMethod[i].value
        ) !== 0) {
          payMethod.payMethod[i].value = (parseFloat(
            payMethod.payMethod[i].value
          ) * rate
          ).toFixed(2);
        } else {
          payMethod.payMethod[i].value = null;
        }
        i++;
      }
    }
    return this.setInvoiceToStr(payMethod);
  }

  ngOnInit() {
    this.inputData = JSON.parse(JSON.stringify(this.data));
    if (this.inputData) {
      if (
        this.inputData.currency === null ||
        this.inputData.currency === undefined
      ) {
        this.inputData.currency = new CurrencyModel();
      }
    }
    this.invoicePayMethod = this.changeCurrency(
      this.inputData.invoicePayMethod,
      this.inputData.rate
    );
    this.createForm();
    this.createGroupModel.totalDue =
      this.currencyPipe.transform(this.inputData.totalDue) || '0.00';
    this.disallowConfirm = this.compareValue(this.createGroupModel);
    this.payMethodPopupService
      .getEditInvoicePaymethod(this.data.invoiceId, this.inputData.currency.code)
      .subscribe(result => {
        if (result) {
          const data = result.json();
          if (data) {
            if (data.hasOwnProperty('invoicePayment')) {
              this.listPaymentShow = <Array<any>>data['invoicePayment'];
              if (this.listPaymentShow.length > 0) {
                this.listPaymentShow.forEach(payment => {
                  if (payment.notOnEdit === false) {
                    this.arrResultPay.push({ id: payment.id, paymenthodId: payment.paymenthodId });
                  }
                });
              }
            }
            this.listPaymentType = data['paymethod'];
          }
        }
      });
  }

  createForm() {
    this.createGroupForm = this.formBuilder.group({
      totalDue: [this.createGroupModel.totalDue || '0.00'],
      totalEntered: [
        this.createGroupModel.totalDue || '0.00',
        [this.totalEnteredValidator]
      ],
      adjustment: [this.invoicePayMethod.adjustment],
      due: [this.createGroupModel.totalDue || '0.00'],
      payMethod: this.createFields(this.invoicePayMethod.payMethod)
    });
  }

  createFields(payMethod: PayMethodObjModel[]): FormArray {
    if (payMethod.length) {
      let i = 0;
      const lens = payMethod.length;
      const formArr = new FormArray([]);
      while (i < lens) {
        formArr.controls.push(this.createAField(payMethod[i]));
        i++;
      }
      return formArr;
    }
    return null;
  }

  createAField(invoiceModel: PayMethodObjModel): FormControl {
    return this.formBuilder.control(invoiceModel.value);
  }

  totalEnteredValidator(control: AbstractControl) {
    const group = control.parent;
    if (group) {
      if (
        !(
          group.controls['totalEntered'].value ===
          group.controls['totalDue'].value
        )
      ) {
        control.markAsTouched();
        return { invalidTotalPayment: true };
      }
    }
    return null;
  }

  inputChange(
    event: { IsInvalidNumber: boolean; Value: string; Id: string },
    formCtrl: FormControl,
    payMethod
  ) {
    if (event.IsInvalidNumber === true) {
      formCtrl.setValue(event.Value);
      this.valueOnChange();
    }
  }

  onKeyUp(event: KeyboardEvent, ele: FormControl) {
    if (ele.value) {
      let i = 0;
      let arr = <string>ele.value;
      let changed = false;
      while (i < arr.length) {
        if (isNaN(parseInt(arr[i], 0)) && arr[i] !== '.' && arr[i] !== '-') {
          arr = arr.substring(0, i);
          changed = true;
        }
        i++;
      }
      if (changed) {
        ele.setValue(arr);
      }
    }
    this.valueOnChange();
  }

  checkIsValue(val: any) {
    if (val === null || val === undefined) {
      return 0;
    }
    return parseFloat(val.toString()) || 0;
  }

  valueOnChange() {
    this.invoicePayMethod = this.calcTotal(this.invoicePayMethod);
    this.createGroupModel.totalEntered = this.calcTotalEntered(
      this.invoicePayMethod
    );
    this.createGroupModel.due = this.calcDue(this.createGroupModel);
    this.createGroupForm.controls['totalDue'].setValue(
      this.createGroupModel.totalDue
    );
    this.createGroupForm.controls['due'].setValue(this.createGroupModel.due);
    this.createGroupForm.controls['totalEntered'].setValue(
      this.createGroupModel.totalEntered
    );
    this.disallowConfirm = this.compareValue(this.createGroupModel);
  }

  setInvoiceToStr(invoice: InvoicePayMethodModel) {
    if (invoice) {
      invoice.adjustment = invoice.adjustment ? this.currencyPipe.transform(invoice.adjustment) : null;
      if (invoice.payMethod) {
        let i = 0;
        while (i < invoice.payMethod.length) {
          if (invoice.payMethod[i].value) {
            invoice.payMethod[i].value = this.currencyPipe.transform(
              invoice.payMethod[i].value.toString()
            );
          }
          i++;
        }
      }
    }
    return invoice;
  }

  checkMinus(str: string) {
    if (str) {
      let i = 0;
      const lens = str.length;
      let count = 0;
      while (i < lens) {
        if (str[i] === '-' && i > 0) {
          count++;
          break;
        }
        i++;
      }
      return count > 0 ? true : false;
    }
    return false;
  }

  calcTotal(invoice: InvoicePayMethodModel) {
    if (invoice) {
      if (invoice.adjustment !== null) {
        if (this.checkMinus(invoice.adjustment.toString())) {
          invoice.adjustment = this.directive.check(invoice.adjustment);
        }
      }
      if (invoice.payMethod) {
        let i = 0;
        const lens = invoice.payMethod.length;
        while (i < lens) {
          if (invoice.payMethod[i].value !== null) {
            if (this.checkMinus(invoice.payMethod[i].value.toString())) {
              invoice.payMethod[i].value = this.directive.check(
                invoice.payMethod[i].value
              );
            }
          }
          i++;
        }
      }
    }
    return invoice || new InvoicePayMethodModel();
  }

  calcTotalEntered(payMethod: InvoicePayMethodModel): string {
    let sum = payMethod.adjustment ? parseFloat(payMethod.adjustment) || 0 : 0;
    if (payMethod.payMethod) {
      if (payMethod.payMethod.length) {
        let i = 0;
        while (i < payMethod.payMethod.length) {
          let value = 0;
          if (payMethod.payMethod[i].value) {
            value = payMethod.payMethod[i].value;
          }
          if (value !== null) {
            sum += parseFloat(value.toString());
          }
          i++;
        }
      }
    }
    return this.currencyPipe.transform(sum.toFixed(2));
  }

  calcDue(payMethod: PayMethodModel) {
    const totalDue = (parseFloat(payMethod.totalDue) -
      parseFloat(payMethod.totalEntered)
    ).toFixed(2);
    payMethod.due = this.currencyPipe.transform(totalDue);
    return this.currencyPipe.transform(payMethod.due);
  }

  compareValue(payMethod: PayMethodModel): boolean {
    return (
      this.currencyPipe.transform(payMethod.totalEntered) !==
      this.currencyPipe.transform(payMethod.totalDue)
    );
  }

  checkMatch(payMethod: PayMethodModel) {
    if (payMethod) {
      return payMethod.totalDue === payMethod.totalEntered;
    }
    return false;
  }

  checkIsNumber(value): boolean {
    const newValue = parseFloat(value);
    return !isNaN(newValue);
  }

  onSubmit() {
    if (this.createGroupForm.valid) {
      if (this.checkMatch(this.createGroupModel) === false) {
        this.dialogService.openErrorDialog({
          message: Utility.stringFormat(AppMessages.payment.errorNotMatch, [
            'Total due',
            'Total Entered'
          ])
        });
      } else {
        // Call Api create invoice
        let data = {
          payMethod: [],
          paymentAmount: 0,
          isDataEntryMode: false
        };
        data['paymentAmount'] = this.invoicePayMethod.paymentAmount;
        data['isDataEntryMode'] = this.inputData.isDataEntryMode;
        if (this.checkIsNumber(this.invoicePayMethod.adjustment)) {
          data['adjustment'] = this.invoicePayMethod.adjustment;
        }
        this.invoicePayMethod.payMethod.forEach(element => {
          if (this.checkIsNumber(element.value)) {
            data.payMethod.push(element);


          }
        });
        this.isAssignSuccess = true;
        this.onCloseDialog(data);
        /*  this.dialogService.openComponentDialog(ConfirmPayMethodPopupComponent).subscribe(result => {
                     if (result) {
                         this.isAssignSuccess = true;
                         this.onCloseDialog();
                         this.router.navigateByUrl('consultation/waiting-room');
                     }
                 }); */
      }
    }
  }

  public onCloseDialog(invoicePaymethod = null) {
    this.dialogRef.close({
      isAssignSuccess: this.isAssignSuccess,
      invoicePayMethod: invoicePaymethod,
    });
  }

  onSavePayment() {
    this.payMethodPopupService
      .updateEditInvoicePaymethod(this.arrResultPay)
      .subscribe(result => {
        if (result) {
          this.onCloseDialog();
        }
      });
  }

  onChangePayMethod(paymethodId, payment) {
    if (this.arrResultPay) {
      const index = this.arrResultPay.findIndex(
        item => item.id === payment.id
      );
      if (index >= 0) {
        this.arrResultPay[index].paymenthodId = paymethodId;
      }
    }
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation/cash-sale/pay-method-popup.component.ts